module.exports = __webpack_public_path__ + "img/kh.eb17c9be.svg";